import script from "./ChangeUserPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeUserPassword.vue?vue&type=script&setup=true&lang=js"

import "./ChangeUserPassword.vue?vue&type=style&index=0&id=32b06dbe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b06dbe"]])

export default __exports__